import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CartActions, MultiCartState } from '@spartacus/cart/base/core';
import { map } from 'rxjs/operators';

import { KnBrQuoteContextService } from '../kn-br-quote-context/kn-br-quote-context.service';
import {
  KnBrCartAddUpdateContext,
  KnBrCartContextActions,
  KnBrCartContextActionTypes,
  KnBrCartLoadSuccessContext,
  KnBrCartRemoveContext,
  KnBrCartResetContext,
} from './kn-br-cart-context.actions';
import { KnBrCartContextAdapter } from './kn-br-cart-context.adapter';

@Injectable()
export class KnBrCartContextEffects {
  loadCartContext$ = createEffect(() => this.actions$.pipe(
    ofType(KnBrCartContextActionTypes.KnBrCartContextLoadAction),
    map((x) => {
      const context = this.knBrCartContextAdapter.get();
      return new KnBrCartLoadSuccessContext(context);
    })
  ));
  addUpdateCartContext$ = createEffect(() => this.actions$.pipe(
    ofType(KnBrCartContextActionTypes.KnBrCartContextAddUpdateAction),
    map((action: KnBrCartAddUpdateContext) => action.payload),
    map((cartCode: string) => {
      // Persist first so the storage write survives a later failure in this effect.
      this.knBrCartContextAdapter.set(cartCode);
      this.knBrQuoteContextService.delete();
      this.store.dispatch(new CartActions.SetActiveCartId(cartCode));
    })
  ), { dispatch: false });
  removeCartContext$ = createEffect(() => this.actions$.pipe(
    ofType(KnBrCartContextActionTypes.KnBrCartContextRemoveAction),
    map((action: KnBrCartRemoveContext) => action.payload),
    map((cartCode: any) => {
      this.store.dispatch(new CartActions.ClearCartState());
      this.knBrCartContextAdapter.remove();
    })
  ), { dispatch: false });
  resetCartContext$ = createEffect(() => this.actions$.pipe(
    ofType(KnBrCartContextActionTypes.KnBrCartContextResetAction),
    map((action: KnBrCartResetContext) => action.payload),
    map((cartCode: any) => {
      this.store.dispatch(new CartActions.ClearCartState());
      this.store.dispatch(new CartActions.SetActiveCartId(''));
      this.knBrCartContextAdapter.remove();
      localStorage.removeItem('spartacus⚿carlisle-customer⚿cart');
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions<KnBrCartContextActions>,
    private knBrCartContextAdapter: KnBrCartContextAdapter,
    private store: Store<MultiCartState>,
    private knBrQuoteContextService: KnBrQuoteContextService
  ) {}
}
